module.exports = __webpack_public_path__ + "static/blog-post-1.4-f5c31d2564aa276f29727d4adf61bfba.png";